import { stepConfigItem } from './types';

const stepsSchema: stepConfigItem[] = [
  { id: 'sex', slug: 'sex' },
  { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
  { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
  { id: 'summary', slug: 'summary' },
];

export default stepsSchema;
